import { SearchPropertyStatus } from '../../types';
import {
  getPropertyStatusFromUrl,
  getPropertyTypesFromUrl,
  getMinBathroomsFromUrl,
  getMinBedroomsFromUrl,
  getMinLandSizeFromUrl,
  getIndoorFeaturesFromUrl,
  getOutdoorFeaturesFromUrl,
  getEcoFriendlyFeaturesFromUrl,
  getMinCarSpacesFromUrl,
  getKeywordsFromUrl,
  getExcludeUnderOfferFromUrl,
  getHasImagesFromUrl,
  getExcludeDepositTakenFromUrl,
} from './queryStringHelpers';

interface PropertyConfigFilters {
  propertyStatus: SearchPropertyStatus;
  propertyTypes: string;
  minBathrooms: string;
  minBedrooms: string;
  minLandSize: string;
  indoorFeatures: string;
  outdoorFeatures: string;
  ecoFriendlyFeatures: string;
  minCarSpaces: string;
  keywords: string;
  excludeUnderOffer: string;
  hasImages: string;
  excludeDepositTaken: string;
}

export const getPropertyConfigFiltersFromUrl = (url: string): PropertyConfigFilters => {
  return {
    propertyStatus: getPropertyStatusFromUrl(url),
    propertyTypes: getPropertyTypesFromUrl(url),
    minBathrooms: getMinBathroomsFromUrl(url),
    minBedrooms: getMinBedroomsFromUrl(url),
    minLandSize: getMinLandSizeFromUrl(url),
    indoorFeatures: getIndoorFeaturesFromUrl(url),
    outdoorFeatures: getOutdoorFeaturesFromUrl(url),
    ecoFriendlyFeatures: getEcoFriendlyFeaturesFromUrl(url),
    minCarSpaces: getMinCarSpacesFromUrl(url),
    keywords: getKeywordsFromUrl(url),
    excludeUnderOffer: getExcludeUnderOfferFromUrl(url),
    hasImages: getHasImagesFromUrl(url),
    excludeDepositTaken: getExcludeDepositTakenFromUrl(url),
  };
};
